import { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SupabaseRestrictionBanner from "./SupabaseRestrictionBanner";

const MinimalLayout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="flex flex-col min-h-screen bg-bbz-cream">
      <Navbar isOpen={isMenuOpen} toggle={toggleMenu} />
      <SupabaseRestrictionBanner />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MinimalLayout;
